import React, { useContext, useEffect } from 'react'
import { Container } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { GeneralContext } from '../../context/'
import DiscountManager from './components/DiscountManager'

const Index = () => {
    const { setBreadcrumb } = useContext(GeneralContext)

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Descuentos`,
            parentLink: '/discounts',
            item: `Descuentos y Cupones`
        })
    }, []) // eslint-disable-line

    return (
        <div className="page-content">
            <Container fluid>
                <DiscountManager />
            </Container>
        </div>
    )
}

export default withRouter(Index)
